import React from 'react'
import { useRef, useState } from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import Typewriter from 'typewriter-effect'

import { Mono } from './Typography'

const fadeIn = keyframes`
  99% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
`

const ContactFormWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  height: auto;
  background-color: ${props =>
    props.light ? 'var(--terminal-400)' : 'var(--terminal-500)'};
  padding: 24px 24px 8px 24px;
  box-shadow: 0px 60px 80px rgba(0, 0, 0, 0.2),
    0px 24px 36px rgba(0, 0, 0, 0.16), 0px 4px 8px rgba(0, 0, 0, 0.12);
`

const ContactFormButtons = styled.div`
  float: left;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${props =>
    props.light ? 'var(--terminal-400)' : 'var(--terminal-500)'};
  border: 1px solid var(--terminal-300);
`

const ContactFormPrompt = styled.div`
  ${Mono};
  color: var(--firewall-300);
  margin-block-start: 0;
  margin-block-end: 0;
  animation: ${fadeIn} ${props => props.delay}s;
  animation-fill-mode: forwards;
  visibility: ${props => (props.delay ? 'hidden' : 'visible')};
`

const ContactFormBody = styled.div`
  ${Mono};
  color: var(--terminal-100);
  display: inline-block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-bottom: 16px;
  animation: ${fadeIn} ${props => props.delay}s;
  animation-fill-mode: forwards;
  visibility: hidden;

  a {
    color: var(--screen-300);
    text-decoration: none;
  }

  input {
    ${Mono};
    color: var(--terminal-0);
    display: block;
    background: transparent;
    border: none;
    width: 100%;
    line-height: 150%;
    margin-bottom: 24px;

    :focus {
      outline: none;
    }

    ::-webkit-input-placeholder {
      color: var(--terminal-300);
      opacity: 1;
    }
  }

  button {
    ${Mono};
    color: var(--screen-300);
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
`

const TypewriterWrapper = styled.div`
  ${Mono};
  color: var(--terminal-0);
  padding-left: 12px;
  margin-block-start: 0;
  margin-block-end: 0;
`

const PromptWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`

const ContactForm = ({ light }) => {
  const formRef = useRef()
  const [formSent, setFormSent] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    let myForm = formRef.current
    let formData = new FormData(myForm)
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => console.log('Form successfully submitted'), setFormSent(true))
      .catch(error => alert(error))
  }

  return (
    <React.Fragment>
      <ContactFormWrapper light={light}>
        <ContactFormButtons light={light} />
        <ContactFormButtons light={light} />
        <ContactFormButtons light={light} />
        <br />
        <PromptWrapper>
          <ContactFormPrompt>→ ~</ContactFormPrompt>
          <TypewriterWrapper>
            <Typewriter
              options={{ delay: 50 }}
              onInit={typewriter => {
                typewriter
                  .callFunction(state => {
                    state.elements.cursor.style.display = 'none'
                  })
                  .typeString('supergood --contact-us')
                  .start()
              }}
            />
          </TypewriterWrapper>
        </PromptWrapper>
        <ContactFormBody delay={2}>
          Let’s talk about a project. Send us a message by emailing{' '}
          <a href="mailto: contact@super.gd">contact@super.gd</a> or use the
          form below.
          <form
            name="contact"
            method="post"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
            ref={formRef}
          >
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="contact" />
            <br />
            <label>
              Your Name:{' '}
              <input
                type="text"
                name="name"
                placeholder="Type your name"
                required
              />
            </label>
            <label>
              Your Email Address:{' '}
              <input
                type="email"
                name="email"
                placeholder="Type your email address"
                required
              />
            </label>
            <label>
              Your Message:{' '}
              <input
                name="message"
                placeholder="Tell us what you have in mind"
                minlength="16"
                required
              ></input>
            </label>
            {formSent ? (
              <a>Thank you, your form was sent.</a>
            ) : (
              <button type="submit">Send →</button>
            )}
          </form>
        </ContactFormBody>
      </ContactFormWrapper>
    </React.Fragment>
  )
}

export default ContactForm
